import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/architecture-validation-report/page.tsx");
